<footer><i>Made with love and Svelte</i></footer>
